import './index.css';

export default {
  name: 'Bcard',
  props: {
    title: { type: String, default: () => '编辑' },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class="b-card">
        <el-card {...{ attrs }}>
          {(this.title != '' || this.$listeners.cancel) && (
            <div slot="header" class="clearfix">
              {this.title != '' && (<span>{this.title}</span>)}
              {this.$listeners.cancel && (<el-button type="text" on-click={this.cancel}>返回 <code>{`>>`}</code></el-button>)}
            </div>
          )}
          {this.$slots.default}
        </el-card>
      </div>
    );
  }
}